/** @jsxImportSource @emotion/react */
import { useLanguage } from "../LanguageContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAnalysis, getAnalysisInIntervals } from "../services/analysisService";
import AnalysesHeader from "components/MainComponents/Analyses/FormComponents/AnalyseHeader";
import Result from "components/MainComponents/Analyses/FormComponents/Result";
import { useToast } from "@coreai/component-library";

export default function AnalysisResultPage() {
  const [newAnalysis, setNewAnalysis] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const [analysisId, setAnalysisId] = useState<string | null>(null);
  const [analysisData, setAnalysisData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { t } = useLanguage();

  useEffect(() => {
    const id = searchParams.get("analysis");
    if (id) {
      setAnalysisId(id);
    }
  }, [searchParams]);

  const fetchAnalysisData = async (id: string) => {
    setLoading(true);
    setError(null);
  
    try {
      const data = await getAnalysis(id);
      setAnalysisData(data);
      if (data.status !== "finished" && data.status !== "error") {
        getAnalysisInIntervals(id).then((finalData) => {
          setAnalysisData(finalData);
        }).catch((err) => {
          console.error(err);
          toast({
            variant: "error",
            description: t("form_assetErrorMsg"),
          });
          navigate("/analyses");
        });
      }
      setLoading(false);
    } catch (err: any) {
      if (err?.status === 404) {
        toast({
          variant: "error",
          description: t("analysis_result_not_found"),
        });
        navigate("/analyses");
      } else {
        setError("Failed to fetch analysis data.");
      }
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (analysisId) {
      fetchAnalysisData(analysisId);
    }
  }, [analysisId]);

  useEffect(() => {
    if (newAnalysis) {
      navigate("/analyses?newAnalysis=true");
    }
  }, [newAnalysis, navigate]);

  return (
    <>
      <div>
        <AnalysesHeader
          setNewAnalysis={setNewAnalysis}
          showSeeAllLink={!!analysisId}
          analysisData={analysisData}
          totalAnalyses={0}
        />
        <Result analysisData={analysisData} loading={loading} />
      </div>
    </>
  );
}
